import request from '@/utils/request'


// 创建订单
export const orderSend = function (data) {
    return request({
        url: '/v1/order/send',
        method: 'post',
        data: data
    })
}

export const orderSendSeat = function (data) {
    return request({
        url: '/v1/order/send_seat',
        method: 'post',
        data: data
    })
}

export const orderPayStatus = function (data) {
    return request({
        url: '/v1/order/getStatus',
        method: 'post',
        data: data
    })
}

export const orderList = function (data) {
    return request({
        url: '/v1/order/getList',
        method: 'post',
        data: data
    })
}

export const orderSetList = function (data) {
    return request({
        url: '/v1/order/getSetList',
        method: 'post',
        data: data
    })
}

export const orderInfo = function (data) {
    return request({
        url: '/v1/order/getInfo',
        method: 'post',
        data: data
    })
}

export const orderPay = function (data) {
    return request({
        url: '/v1/order/orderPay',
        method: 'post',
        data: data
    })
}

export const orderSuccess = function (data) {
    return request({
        url: '/v1/order/orderSuccess',
        method: 'post',
        data: data
    })
}
export const reminder = function (data) {
    return request({
        url: '/v1/order/reminder',
        method: 'post',
        data: data
    })
}
export default {
    orderSend,
    orderSendSeat,
    orderPayStatus,
    orderList,
    orderSetList,
    orderInfo,
    orderPay,
    orderSuccess,
    reminder
}
